import { render, staticRenderFns } from "./ShopNavBar.vue?vue&type=template&id=65df618a&scoped=true&"
import script from "./ShopNavBar.vue?vue&type=script&lang=js&"
export * from "./ShopNavBar.vue?vue&type=script&lang=js&"
import style0 from "./ShopNavBar.vue?vue&type=style&index=0&id=65df618a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65df618a",
  null
  
)

export default component.exports